module.exports = __webpack_public_path__ + "img/left-q.c5bf2013.png";